import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { setBacklink } from '../redux/backlinkSlice';

/**
 * Restituisce una funzione navigateTo(path).
 * Se l'utente è loggato naviga direttamente; altrimenti salva il backlink
 * e rimanda a /register-login?section=Login, da cui LoginForm tornerà
 * alla destinazione originale dopo il login.
 */
const useRequireLogin = () => {
    const isLogged = useSelector(state => state.user.isLogged);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    return (path) => {
        if (isLogged) {
            navigate(path);
        } else {
            dispatch(setBacklink(path));
            navigate('/register-login?section=Login');
        }
    };
};

export default useRequireLogin;
